import React, { useRef, useState } from "react";
import ReactDOM from "react-dom";
import CanvasDraw from "react-canvas-draw";
import { Button } from "antd";
import { useMoralis } from "react-moralis";
import { useIsMobileOrTablet } from "../helpers/isMobileOrTablet";
import { Menu, Dropdown, Popconfirm } from "antd";
import { DownOutlined, SaveOutlined } from "@ant-design/icons";
import { HexColorPicker } from "react-colorful";

import "../styledraw.css";

const styles = {
  buttons: {
    display: "block",
    marginTop: "5px",
    padding: "5px",
    width: "100%",
  },
  button: {
    marginLeft: "5px",
    marginRight: "5px",
    marginTop: "5px",
    padding: "5px",
    width: "100px",
  },
};

const Draw = () => {
  const [color, setColor] = useState("#b32aa9");

  const storedTokenId = localStorage.getItem("StoredIDtoken");
  //const importedTokenId = props.tokenId;
  console.log(
    storedTokenId,
    "returned storedTokenId in child component - must pass storedTokenId from parent - ",
  );

  const { Moralis } = useMoralis();
  const user = Moralis.User.current();
  const useraddress = user.attributes.ethAddress;

  const originCanvas = useRef(null);
  const savedCanvas = useRef(null);
  const isMobOrTab = useIsMobileOrTablet();

  async function SaveOrigin() {
    //external constants
    const MonsterCreature = Moralis.Object.extend("Monster");
    const monster = new MonsterCreature();

    const drawdata = originCanvas.current.getSaveData();

    // get origin draw data pass it to another canvas
    //savedCanvas.current.loadSaveData(drawdata) // load current draw data from front end
    //savedCanvas.current.loadSaveData(storedDrawData) //  load current draw data from databaase
    console.log(drawdata, "saved origin");
    console.log(useraddress, "USER ADDRESS");

    const query = new Moralis.Query("Monster");
    query.equalTo("tokenId", storedTokenId);
    const results = await query.find();
    console.log(results, "results");

    if (results.length > 0) {
      results[0].set("drawData", drawdata);
      results[0].save();
    } else {
      monster.set("userWallet", useraddress); // USET ETH ADDRESS
      monster.set("drawData", drawdata); // STRING
      monster.set("nftName", "Moralis NFT"); // NAME
      monster.set("tokenId", storedTokenId); // TOKEN ID
      await monster.save();
    }

    // query database display drawing
    //const query = new Moralis.Query("Monster");
    //query.equalTo("tokenId", importedTokenId);
    //const results = await query.find();
    //console.log(results);
    // Do something with the returned Moralis.Object values
    for (let i = 0; i < results.length; i++) {
      const object = results[i];
      //console.log(object.id + ' - ' + object.get('tokenId'));
      console.log(object.get("drawData"));
      const storedDrawData = object.get("drawData");
      savedCanvas.current.loadSaveData(storedDrawData); //  load current draw data from databaase
    }
    return monster;
  }

  async function loadSavedDraw() {
    // query database display drawing
    const query = new Moralis.Query("Monster");
    query.equalTo("tokenId", storedTokenId);
    const results = await query.find();
    //console.log(results);
    // Do something with the returned Moralis.Object values
    for (let i = 0; i < results.length; i++) {
      const object = results[i];
      //console.log(object.id + ' - ' + object.get('tokenId'));
      console.log(object.get("drawData"));
      const storedDrawData = object.get("drawData");
      if (storedDrawData) {
        savedCanvas.current.loadSaveData(storedDrawData); //  load current draw data from databaase
      } else alert("There is no Drawing to load. Plese Draw something first");
    }
  }

  const clearOrigin = () => {
    originCanvas.current.clear();
  };
  const undoAction = () => {
    originCanvas.current.undo();
  };

  /// pop up confirm
  const [visible, setVisible] = React.useState(false);
  const [visibleClear, setVisibleClear] = React.useState(false);
  const [confirmLoading, setConfirmLoading] = React.useState(false);
  const [confirmLoadingClear, setConfirmLoadingClear] = React.useState(false);

  const showPopconfirm = () => {
    setVisible(true);
  };

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setVisible(false);
      setConfirmLoading(false);
    }, 2000);
    SaveOrigin();
  };

  const showPopconfirmClear = () => {
    setVisibleClear(true);
  };

  const handleClear = () => {
    setConfirmLoadingClear(true);
    setTimeout(() => {
      setVisibleClear(false);
      setConfirmLoadingClear(false);
    }, 2000);
    clearOrigin();
  };

  const handleCancel = () => {
    console.log("Clicked cancel button");
    setVisible(false);
  };

  return (
    <div className="Drawer">
      <div className="value" style={{ borderLeftColor: color }}>
        You are editing Token ID: {storedTokenId}
      </div>
      <h1>Draw Here</h1>
      <p style={{ marginLeft: "-450px", fontWeight: "800" }}>
        <span role="img" aria-label="fingers pointing down">
          👇👇👇👇
        </span>{" "}
        Use your {isMobOrTab ? "finger" : "mouse"} to draw{" "}
      </p>
      <div
        style={{
          marginTop: "5px",
          marginLeft: "-300px",
        }}
      >
        {/* VISIBLE VALUE <div className="value" style={{ borderLeftColor: color }}>
          Current color is {color}
        </div>*/}

        <CanvasDraw
          style={{
            float: "left",
            display: "block",
            boxShadow:
              "0 13px 27px -5px rgba(50, 50, 93, 0.25),    0 8px 16px -8px rgba(0, 0, 0, 0.3)",
          }}
          canvasWidth={"300px"}
          canvasHeight={"300px"}
          brushRadius={1}
          brushColor={color}
          gridColor={"gray"}
          ref={originCanvas}
        />
        <HexColorPicker
          style={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            width: "144px",
            height: "137px",
            paddingLeft: "10px !important",
            paddingRight: "10px !important",
          }}
          color={color}
          onChange={setColor}
        />

        <div style={styles.buttons}>
          <Popconfirm
            title="Are you sure you want to clear?"
            visible={visibleClear}
            onConfirm={handleClear}
            okButtonProps={{ loading: confirmLoadingClear }}
            onCancel={handleCancel}
          >
            <Button
              style={styles.button}
              key="clear"
              onClick={() => showPopconfirmClear()}
            >
              Clear
            </Button>
          </Popconfirm>
          <Button
            style={styles.button}
            key="undo"
            type="primary"
            onClick={() => undoAction()}
          >
            Undo
          </Button>
          <Popconfirm
            title="Are you sure you want to save?"
            visible={visible}
            onConfirm={handleOk}
            okButtonProps={{ loading: confirmLoading }}
            onCancel={handleCancel}
          >
            <Button
              style={styles.button}
              type="primary"
              icon={<SaveOutlined />}
              onClick={() => showPopconfirm()}
            >
              Save!
            </Button>
          </Popconfirm>

          <Button
            style={styles.button}
            key="submit"
            type="primary"
            onClick={() => loadSavedDraw()}
          >
            Load Saved
          </Button>
        </div>
      </div>
      <div style={{ marginLeft: "440px", marginTop: "-300px", float: "left" }}>
        <CanvasDraw
          style={{
            boxShadow:
              "0 13px 27px -5px rgba(50, 50, 93, 0.25), 0 8px 16px -8px rgba(0, 0, 0, 0.3)",
            border: "1px solid black",
            float: "right",
          }}
          canvasWidth={"300px"}
          canvasHeight={"300px"}
          brushRadius={1}
          brushColor={"black"}
          hideGrid={true}
          disabled={true}
          ref={savedCanvas}
        />
      </div>
    </div>
  );
};
export default Draw;
